<template>
    <div id="wrapper" :key="valuekey">
        <div class="content-page">
            <div class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-12">
                            <div class="page-title-box">
                                <h4 class="page-title">
                                    {{ $t('string.msg.companies.manager.user.label.title') }}
                                </h4>
                            </div>
                        </div>
                    </div>
                    <!-- Form row -->
                    <div class="row">
                        <div class="col-md-12">
                            <div class="card-box">
                                <p class="sub-header">
                                    {{ $t('string.msg.user.label.data.company.decription') }}
                                </p>
                                <form>
                                    <div class="form-row" v-show="data._id">
                                        <div class="form-group col-md-6">
                                            <label class="col-form-label">
                                                <code class="highlighter-rouge">*</code>
                                                {{ $t('string.msg.product.brand.label.id') }}
                                            </label>
                                            <input type="text" readonly v-model="data._id" class="form-control" />
                                        </div>
                                        <div class="form-group col-md-3">
                                            <label class="col-form-label">
                                                <code class="highlighter-rouge">*</code>
                                                {{ $t('string.msg.company.label.status') }}
                                            </label>
                                            <select v-model="data.status" class="form-control"
                                                @change="onChangeStatus($event)">
                                                <option value="-1" selected>
                                                    {{ $t('string.msg.element.select.selectitem') }}
                                                </option>
                                                <option value="ACTIVE">
                                                    {{ $t('string.msg.active') }}
                                                </option>
                                                <option value="ARCHIVED">
                                                    {{ $t('string.msg.archived') }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label class="col-form-label">
                                                <code class="highlighter-rouge">*</code>
                                                {{ $t('string.msg.company.label.fantasyName') }}
                                            </label>
                                            <input type="text" v-model="data.fantasyName" @keydown.enter.prevent
                                                class="form-control"
                                                :placeholder="$t('string.msg.company.placeholder.fantasyName')" />
                                        </div>

                                        <div class="form-group col-md-6">
                                            <label class="col-form-label">
                                                <code class="highlighter-rouge">*</code>
                                                {{ $t('string.msg.company.label.socialName') }}
                                            </label>
                                            <input type="text" v-model="data.socialName" @keydown.enter.prevent
                                                class="form-control"
                                                :placeholder="$t('string.msg.company.placeholder.socialName')" />
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label class="col-form-label">
                                                <code class="highlighter-rouge">*</code>
                                                {{ $t('string.msg.company.label.document') }}
                                            </label>
                                            <input type="text" v-model="data.document" @keydown.enter.prevent
                                                v-mask="['###.###.###-##', '##.###.###/####-##']" class="form-control"
                                                :placeholder="$t('string.msg.company.placeholder.document')" />
                                        </div>

                                        <div class="form-group col-md-6">
                                            <label class="col-form-label">
                                                {{ $t('string.msg.company.label.stateSubscription') }}
                                            </label>
                                            <input @keydown.enter.prevent v-model="data.stateSubscription" type="text"
                                                class="form-control"
                                                :placeholder="$t('string.msg.company.placeholder.stateSubscription')" />
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label class="col-form-label">
                                                <code v-if="!data._id" class="highlighter-rouge">*</code>
                                                {{ $t('string.msg.company.label.primaryPhone') }}
                                            </label>
                                            <input @keydown.enter.prevent v-model="data.primaryPhone" type="text"
                                                class="form-control"
                                                :placeholder="$t('string.msg.company.placeholder.primaryPhone')"
                                                v-mask="['(##) ####-####', '(##) #####-####']" />
                                        </div>

                                        <div class="form-group col-md-6">
                                            <label class="col-form-label">
                                                <code v-if="!data._id" class="highlighter-rouge">*</code>
                                                {{ $t('string.msg.company.label.main.email') }}
                                            </label>
                                            <input type="text" @keydown.enter.prevent v-model="data.email"
                                                class="form-control"
                                                :placeholder="$t('string.msg.company.placeholder.main.email')" />
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label class="col-form-label">
                                                {{ $t('string.msg.company.label.secondaryPhone') }}
                                            </label>
                                            <input @keydown.enter.prevent v-model="data.secondaryPhone" type="text"
                                                class="form-control"
                                                :placeholder="$t('string.msg.company.placeholder.primaryPhone')"
                                                v-mask="['(##) ####-####', '(##) #####-####']" />
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label class="col-form-label">
                                                {{ $t('string.msg.company.label.talkto') }}
                                            </label>
                                            <input v-model="data.talkTo" @keydown.enter.prevent type="text"
                                                class="form-control"
                                                :placeholder="$t('string.msg.company.placeholder.talkto')" />
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label class="col-form-label">
                                                <code class="highlighter-rouge">*</code>
                                                {{ $t('string.msg.company.label.isbranch') }}
                                            </label>
                                            <select @keydown.enter.prevent v-model="data.isBranch" class="form-control">
                                                <option :value="false">
                                                    {{ $t('string.msg.no') }}
                                                </option>
                                                <option :value="true">
                                                    {{ $t('string.msg.yes') }}
                                                </option>
                                            </select>
                                        </div>

                                        <div v-if="data.isBranch == true" class="form-group col-md-6">
                                            <label class="col-form-label">
                                                <code class="highlighter-rouge">*</code>
                                                {{ $t('string.msg.company.label.document.main') }}
                                            </label>
                                            <input type="tel" @keydown.enter.prevent v-mask="'##.###.###/####-##'"
                                                v-model="data.mainCompany" class="form-control"
                                                :placeholder="$t('string.msg.company.placeholder.document')" />
                                        </div>
                                    </div>
                                

                                    <div class="form-row" v-if="data.address">
                                        <div class="form-group col-sm-2">
                                            <label>
                                                <code class="highlighter-rouge">*</code>
                                                {{ $t('string.msg.company.label.cep') }}
                                            </label>
                                            <input @blur="loadInfosByCEP" @keydown.enter.prevent v-mask="'#####-###'"
                                                v-model="data.address.cep" type="te" class="form-control"
                                                :placeholder="$t('string.msg.company.label.cep')" />
                                        </div>
                                    </div>

                                    <div v-if="data.address && data.address.cep && data.address.cep.length == 9" class="form-row">
                                        <div class="form-group col-sm-2">
                                            <label>
                                                <code class="highlighter-rouge">*</code>
                                                {{ $t('string.msg.company.label.state') }}
                                            </label>
                                            <select v-model="data.address.state" class="form-control select2">
                                                <option value="-1" selected>
                                                    {{ $t('string.msg.element.select.selectitem') }}
                                                </option>
                                                <option value="AC">AC</option>
                                                <option value="AL">AL</option>
                                                <option value="AP">AP</option>
                                                <option value="AM">AM</option>
                                                <option value="BA">BA</option>
                                                <option value="CE">CE</option>
                                                <option value="DF">DF</option>
                                                <option value="ES">ES</option>
                                                <option value="GO">GO</option>
                                                <option value="MA">MA</option>
                                                <option value="MT">MT</option>
                                                <option value="MS">MS</option>
                                                <option value="MG">MG</option>
                                                <option value="PA">PA</option>
                                                <option value="PB">PB</option>
                                                <option value="PR">PR</option>
                                                <option value="PE">PE</option>
                                                <option value="PI">PI</option>
                                                <option value="RJ">RJ</option>
                                                <option value="RN">RN</option>
                                                <option value="RS">RS</option>
                                                <option value="RO">RO</option>
                                                <option value="RR">RR</option>
                                                <option value="SC">SC</option>
                                                <option value="SP">SP</option>
                                                <option value="SE">SE</option>
                                                <option value="TO">TO</option>
                                            </select>
                                        </div>
                                        <div class="col-sm-4">
                                            <label>
                                                <code class="highlighter-rouge">*</code>
                                                {{ $t('string.msg.company.label.city') }}
                                            </label>
                                            <input v-model="data.address.city" @keydown.enter.prevent type="text"
                                                class="form-control" :placeholder="$t('string.msg.company.label.city')" />
                                        </div>
                                        <div class="form-group col-sm-4">
                                            <label>
                                                <code class="highlighter-rouge">*</code>
                                                {{ $t('string.msg.company.label.street') }}
                                            </label>
                                            <input v-model="data.address.address" @keydown.enter.prevent type="text"
                                                class="form-control" :placeholder="$t('string.msg.company.label.street')" />
                                        </div>
                                        <div class="form-group col-sm-2">
                                            <label>
                                                <code class="highlighter-rouge">*</code>
                                                {{ $t('string.msg.company.label.number') }}
                                            </label>
                                            <input v-model="data.address.number" @keydown.enter.prevent type="text"
                                                class="form-control" :placeholder="$t('string.msg.company.label.number')" />
                                        </div>
                                    </div>

                                    <div v-if="data.address && data.address.cep && data.address.cep.length == 9" class="form-row">
                                        <div class="form-group col-sm-5">
                                            <label>
                                                <code class="highlighter-rouge">*</code>
                                                {{ $t('string.msg.company.label.neighborhood') }}
                                            </label>
                                            <input v-model="data.address.neighborhood" @keydown.enter.prevent type="text"
                                                class="form-control"
                                                :placeholder="$t('string.msg.company.label.neighborhood')" />
                                        </div>
                                        <div class="form-group col-sm-4">
                                            <label>
                                                {{ $t('string.msg.company.label.complement') }}
                                            </label>
                                            <input v-model="data.address.complement" @keydown.enter.prevent type="text"
                                                class="form-control"
                                                :placeholder="$t('string.msg.company.label.complement')" />
                                        </div>
                                    </div>

                                

                                    <div class="form-row">
                                        <div class="form-group col-md-12">
                                            <label class="col-form-label">
                                                <code class="highlighter-rouge">*</code>
                                                {{ $t('string.msg.company.label.type') }}
                                            </label>
                                            <div class="d-flex flex-wrap">
                                                <div class="container-switch" v-bind:key="item.id"
                                                    v-for="item in this.types">
                                                    <label class="switch">
                                                        <input v-model="data.typeService" type="checkbox" :id="item._id"
                                                            :value="item._id" :true-value="item._id" :false-value="null" />
                                                        <span class="slider round"></span>
                                                    </label>
                                                    <span class="label-swith">{{ item.name }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group col-md-3">
                                        <label class="col-form-label">
                                            {{ $t('string.msg.company.label.isGeoreferencedCompany') }}
                                        </label>
                                        <select v-model="data.isGeoreferencedCompany" class="form-control">
                                            <option :value="null" selected>
                                                {{ $t('string.msg.element.select.selectitem') }}
                                            </option>
                                            <option :value="true">
                                                {{ $t('string.msg.yes') }}
                                            </option>
                                            <option :value="false">
                                                {{ $t('string.msg.no') }}
                                            </option>
                                        </select>
                                    </div>

                                    <div v-if="data.isGeoreferencedCompany === true">
                                        <div class="form-row">
                                            <div class="form-group col-md-12">
                                                <label class="col-form-label">
                                                    {{ $t('string.msg.company.label.address') }}
                                                </label>
                                                <vue-google-autocomplete ref="address" id="map"
                                                    v-model="data.locale.address" classname="form-control"
                                                    placeholder="Digite o endereço" v-on:placechanged="getAddressData">
                                                </vue-google-autocomplete>
                                            </div>
                                        </div>
                                        <div class="form-row">
                                            <div class="form-group col-md-6">
                                                <label class="col-form-label">
                                                    {{ $t('string.msg.company.geolocation.lat') }}
                                                </label>
                                                <input v-model="data.locale.geolocation.latitude" type="text"
                                                    class="form-control"
                                                    :placeholder="$t('string.msg.company.geolocation.lat')" />
                                            </div>
                                            <div class="form-group col-md-6">
                                                <label class="col-form-label">
                                                    {{ $t('string.msg.company.geolocation.lng') }}
                                                </label>
                                                <input v-model="data.locale.geolocation.longitude" type="text"
                                                    class="form-control"
                                                    :placeholder="$t('string.msg.company.geolocation.lng')" />
                                            </div>
                                        </div>

                                        <div id="accordionService" v-if="tags && tags.length > 0">
                                            <div class="card">
                                                <div class="card-header" id="headingTwoService">
                                                    <h5 class="mb-0">
                                                        <span class="btn btn-link collapsed" data-toggle="collapse"
                                                            data-target="#collapseTwoService" aria-expanded="true"
                                                            aria-controls="collapseTwoService">
                                                            {{ $t('string.msg.companies.list.tags.label') }}
                                                        </span>
                                                    </h5>
                                                </div>

                                                <div class="form-row">
                                                    <div class="form-group col-md-12">
                                                        <div id="collapseTwoService" class="collapse show"
                                                            aria-labelledby="headingTwoService"
                                                            data-parent="#accordionService">
                                                            <div class="card-body">
                                                                <div class="d-flex flex-wrap">
                                                                    <div class="container-switch" v-bind:key="item.id"
                                                                        v-for="item in tags">
                                                                        <label class="switch">
                                                                            <input v-model="data.tags" type="checkbox"
                                                                                :id="item._id" :value="item._id"
                                                                                :true-value="item._id"
                                                                                :false-value="null" />
                                                                            <span class="slider round"></span>
                                                                        </label>
                                                                        <span class="label-swith">{{
                                                                            camelize($t(item._id)).split('ZZZ_').join('')
                                                                        }}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div id="accordionFuel" v-if="tags && tags.length > 0">
                                            <div class="card">
                                                <div class="card-header" id="headingFuel">
                                                    <h5 class="mb-0">
                                                        <span class="btn btn-link collapsed" data-toggle="collapse"
                                                            data-target="#collapseFuel" aria-expanded="true"
                                                            aria-controls="collapseFuel">
                                                            {{ $t('string.msg.companies.fuels.price.label') }}
                                                        </span>
                                                    </h5>
                                                </div>

                                                <div class="form-row">
                                                    <div class="form-group col-md-12">
                                                        <div id="collapseFuel" class="collapse show"
                                                            aria-labelledby="headingFuel" data-parent="#accordionFuel">
                                                            <div class="card-body">
                                                                <div class="flex-wrap">
                                                                    <div class="form-row">
                                                                        <div class="form-group col-md-3">
                                                                            <label class="col-form-label">
                                                                                {{ $t('string.msg.fuel.gnv') }}
                                                                            </label>
                                                                            <input v-model="data.fuels.gnv" v-money="money"
                                                                                type="text" id="gnv" class="form-control" />
                                                                        </div>
                                                                        <div class="form-group col-md-3">
                                                                            <label class="col-form-label">
                                                                                {{ $t('string.msg.fuel.gas') }}
                                                                            </label>
                                                                            <input v-model="data.fuels.gas" v-money="money"
                                                                                type="text" id="gas" class="form-control" />
                                                                        </div>
                                                                        <div class="form-group col-md-3">
                                                                            <label class="col-form-label">
                                                                                {{ $t('string.msg.fuel.premmiumGas') }}
                                                                            </label>
                                                                            <input v-model="data.fuels.premmiumGas"
                                                                                v-money="money" type="text" id="premmiumGas"
                                                                                class="form-control" />
                                                                        </div>
                                                                        <div class="form-group col-md-3">
                                                                            <label class="col-form-label">
                                                                                {{ $t('string.msg.fuel.additiveGas') }}
                                                                            </label>
                                                                            <input v-model="data.fuels.additiveGas"
                                                                                v-money="money" type="text" id="additiveGas"
                                                                                class="form-control" />
                                                                        </div>
                                                                    </div>
                                                                    <div class="form-row">
                                                                        <div class="form-group col-md-3">
                                                                            <label class="col-form-label">
                                                                                {{ $t('string.msg.fuel.ethanol') }}
                                                                            </label>
                                                                            <input v-model="data.fuels.ethanol"
                                                                                v-money="money" type="text" id="ethanol"
                                                                                class="form-control" />
                                                                        </div>
                                                                        <div class="form-group col-md-3">
                                                                            <label class="col-form-label">
                                                                                {{ $t('string.msg.fuel.premmiumEthanol') }}
                                                                            </label>
                                                                            <input v-model="data.fuels.premmiumEthanol"
                                                                                v-money="money" type="text"
                                                                                id="premmiumEthanol" class="form-control" />
                                                                        </div>
                                                                        <div class="form-group col-md-3">
                                                                            <label class="col-form-label">
                                                                                {{ $t('string.msg.fuel.diesel') }}
                                                                            </label>
                                                                            <input v-model="data.fuels.diesel"
                                                                                v-money="money" type="text" id="diesel"
                                                                                class="form-control" />
                                                                        </div>
                                                                        <div class="form-group col-md-3">
                                                                            <label class="col-form-label">
                                                                                {{ $t('string.msg.fuel.dieselS10') }}
                                                                            </label>
                                                                            <input v-model="data.fuels.dieselS10"
                                                                                v-money="money" type="text" id="dieselS10"
                                                                                class="form-control" />
                                                                        </div>
                                                                    </div>
                                                                    <div class="form-row">
                                                                        <div class="form-group col-md-3">
                                                                            <label class="col-form-label">
                                                                                {{ $t('string.msg.fuel.dieselS500') }}
                                                                            </label>
                                                                            <input v-model="data.fuels.dieselS500"
                                                                                v-money="money" type="text" id="dieselS500"
                                                                                class="form-control" />
                                                                        </div>
                                                                        <div class="form-group col-md-3">
                                                                            <label class="col-form-label">
                                                                                {{ $t('string.msg.fuel.electricity') }}
                                                                            </label>
                                                                            <input v-model="data.fuels.electricity"
                                                                                v-money="money" type="text" id="electricity"
                                                                                class="form-control" />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="form-row">
                                            <div class="form-group col-md-6">
                                                <label class="col-form-label">{{ $t('string.msg.gas.stations.label.logo') }}
                                                </label>
                                                <input type="file" id="file" ref="file" v-on:change="handleFileUpload()"
                                                    class="form-control" />
                                            </div>
                                            <div class="form-group col-md-4">
                                                <img v-if="data && data.logoURL" style="object-fit: contain"
                                                    v-bind:src="data.logoURL" alt="image" />
                                            </div>
                                        </div>
                                    </div>

                                    <div v-if="errors.length" class="alert alert-danger">
                                        <p class="lead">
                                            {{ $t('response.msg.error.empty.fields') }}
                                        </p>
                                        <ul>
                                            <li v-bind:key="error" v-for="  error   in   errors  ">
                                                {{ error }}
                                            </li>
                                        </ul>
                                    </div>

                                    <br />

                                    <div class="form-row text-center">
                                        <div class="form-group col-md-6">
                                            <button @click="clearForm" class="btn btn-secondary w-50">
                                                {{ $t('string.msg.form.btn.clear') }}
                                            </button>
                                        </div>
                                        <div class="form-group col-md-6">
                                            <button @click="checkForm" class="btn btn-danger w-50">
                                                {{ $t('string.msg.form.btn.save') }}
                                            </button>
                                        </div>
                                        <!-- <div class="form-group col-md-6" v-if="data.address">
                                            <button v-if="data.address.cep && data.address.cep.length == 9"
                                                @click="checkForm" class="btn btn-danger w-50">
                                                {{ $t('string.msg.form.btn.save') }}
                                            </button>
                                            <button v-else-if="!data.address.cep || data.address.cep.length < 9"
                                                class="btn btn-light w-50">
                                                {{ $t('string.msg.form.btn.save') }}
                                            </button>
                                        </div> -->
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <List v-on:load-item="selectItem" />
                </div>
            </div>
        </div>

        <Spinner />
        <Toast :title="titleToast" :message="messageToast" :messageId="messageIdToast" />
        <Confirmation :title="titleToast" :message="messageToast" :cancelText="cancelText" :yesText="yesText"
            v-on:confirmation-return="archive" />
        <FlashMessage />
    </div>
</template>

<script>
import Controller from './CrtCompany'
import List from './ListCompanies'
import Spinner from '../../../components/layout/Spinner'
import Toast from '../../../components/layout/Toast'
import Confirmation from '../../../components/layout/Confirmation'
import VueGoogleAutocomplete from 'vue-google-autocomplete'
import Vue from 'vue'
Vue.prototype.$eventHub = new Vue()

export default {
    name: 'Company',
    components: {
        Spinner,
        Toast,
        List,
        Confirmation,
        VueGoogleAutocomplete,
    },
    data() {
        return {
            errors: [],
            addresses: [],
            valuekey: 0,
            certifies: [],
            services: [],
            manufacturer: -1,
            manufacturersTruck: [],
            manufacturersTruckTrailer: [],
            familiesTruck: [],
            familiesTruckTrailer: [],
            manufacturerFamilies: [],
            tags: [],
            file: null,
            types: [
                {
                    _id: 'PART_SUPPLIER',
                    name: this.$t('string.msg.company.label.type.autoparts'),
                },
                {
                    _id: 'CERTIFIER',
                    name: this.$t('string.msg.company.label.type.certifier'),
                },
                {
                    _id: 'SERVICE_PROVIDER',
                    name: this.$t('string.msg.company.label.type.serviceprovider'),
                },
                {
                    _id: 'FLEET_DRIVER',
                    name: this.$t('string.msg.company.label.type.fleetdriver'),
                },
                {
                    _id: 'GAS_STATION',
                    name: this.$t('string.msg.user.gasstation.label.title'),
                },
            ],
            titleToast: null,
            messageToast: null,
            messageIdToast: null,
            manufacturers: [],
            families: [],
            lastDocument: null,
            data: {
                auxStatus: 'ACTIVE',
                status: 'ACTIVE',
                isBranch: false,
                fantasyName: null,
                socialName: null,
                email: null,
                document: null,
                isGeoreferencedCompany: false,
                address: {
                    state: -1,
                    cep: null,
                    city: null,
                    address: null,
                    neighborhood: null,
                    number: null,
                },
                primaryPhone: null,
                secondaryPhone: null,
                talkTo: null,
                typeService: [],
                manufacturers: [],
                families: [],
                manufacturerFamilies: [],
                locale: {
                    address: null,
                    geolocation: {
                        latitude: null,
                        longitude: null,
                    },
                },
                tags: [],
                fuels: {
                    gnv: null,
                    gas: null,
                    premmiumGas: null,
                    additiveGas: null,
                    ethanol: null,
                    premmiumEthanol: null,
                    diesel: null,
                    dieselS10: null,
                    dieselS500: null,
                    electricity: null,
                },
            },
            money: {
                decimal: ',',
                thousands: '.',
                prefix: '',
                suffix: '',
                precision: 2,
                masked: false,
                min: 0,
                max: 999,
            },
        }
    },
    methods: Controller.methods,
    created() { },
    mounted() {
        Controller.init(this)
    },
}
</script>

<style></style>
